// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__AhoqQ","alertIcon":"ConfirmModal_alertIcon__1-nzf"};